import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IEditCategoryContext, EditCategoryContext } from '../../../../../../editCategoryState/editCategoryContext';
import { Form } from 'antd';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { useCompareFormData } from 'hooks/useCompareFormData';
import classNames from 'classnames';
import style from './BtnBlock.module.scss';

const BtnBlock: React.FC = () => {
	const {
		changeTypeOfModalWindow,
		isLoading,
		initialFormData,
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		nameOfCategory,
		categoryType,
		isRestricted,
		activationSchedule,
		deactivationSchedule,
		fileId,
		filePath,
		translations,
	} = useContext<IEditCategoryContext>(EditCategoryContext);
	const containerClasses = classNames(style.container, {
		[style.visible]: !isLoading,
	});

	const currentFormData = {
		IDSelectedCustomer,
		IDsSelectedRestaurant,
		nameOfCategory,
		categoryType,
		isRestricted,
		activationSchedule,
		deactivationSchedule,
		filePath: fileId || filePath || null,
		translations,
	};

	const isEqualFormData = useCompareFormData(initialFormData, currentFormData);

	return (
		<Form.Item>
			<div className={containerClasses} data-test="BtnBlock">
				<Button
					className={style.cancelBtn}
					theme="outlined"
					onClick={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
					icon={
						<svg className={style.icon}>
							<use xlinkHref={`${breadcrumbs}#resetIcon`} />
						</svg>
					}>
					<Text translationNameSpace="form" translationKey="cancelButton" asFragment={true} />
				</Button>
				<Button className={style.saveBtn} theme="primaryBlue" disabled={isEqualFormData} type="submit">
					<Text translationNameSpace="form" translationKey="saveButton" asFragment={true} />
				</Button>
			</div>
		</Form.Item>
	);
};

export default BtnBlock;
